import { Component, type ErrorInfo, type ReactNode } from "react";
import ErrorPage from "@/components/Error";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: unknown): State {
    return { error: error instanceof Error ? error : new Error(String(error)) };
  }

  componentDidCatch(error: unknown, info: ErrorInfo): void {
    console.error("Unhandled error caught by AppErrorBoundary", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorPage
          status={500}
          error={this.state.error}
          reset={() => this.setState({ error: null })}
        />
      );
    }

    return this.props.children;
  }
}

